import { Component, Input, OnInit, Optional, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhAlgorithm, VhEventMediator, VhImage } from 'vhautowebdb';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { ManageLibraryComponent, ChooseImageComponent, ChooseIconComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageService } from 'vhobjects-service';
import { DomSanitizer } from '@angular/platform-browser';
import { EditNameComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { AtwImageDetailRepeatAdmin } from './../../../../objects/basic/image-detail-repeat/admin/image-detail-repeat-admin/image-detail-repeat-admin.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'atw-frame-repeat-admin',
  templateUrl: './frame-repeat-admin.component.html',
  styleUrls: ['./frame-repeat-admin.component.scss'],
})

export class AtwFrameRepeatAdmin implements OnInit {
  @Input() data;
  @Input() type;

  listPureData: any[] = []; //
  isOpenModal: boolean = false;
  dataRow: any;
  arr_link_page: any;
  loading = false;
  pageSize = 10;
  pageIndex = 1;
  total = 1;

  sources = [
    {
      label: 'tai_anh_len',
      value: 'device'
    },
    {
      label: 'thu_vien',
      value: 'library'
    },
    {
      label: 'kho_anh_dung_chung',
      value: 'free_img'
    },
    {
      label: 'duong_dan_hinh_anh',
      value: 'url'
    },
  ]
  source = 'device';
  subproject: any;
  id_subproject: string = '';

  isShowUploadToServer = false;
  compressType = 'compress-frame'
  isSharedImg = true;
  compressWidth = 100;
  compressHeight = 100;
  uploadToServerLoading = false;

  isOpenGuideMap = false;
  isOpenGuideVideo = false;
  radioValue = ''; //Biến này dùng để phân biệt kiểu bản đồ người dùng muốn add

  dataLoaded: boolean = false; // Biến cờ để kiểm tra xem dữ liệu đã được tải hay chưa

  type_link: any = [
    { value: 'none', label: 'khong' },
    { value: 'page_link', label: 'den_trang' },
    { value: 'navigation_link', label: 'lien_ket_dieu_huong' },
    { value: 'hyper_link', label: 'lien_ket_trang_khac' },
    { value: 'mailto', label: 'Email' },
    { value: 'tel', label: 'so_dien_thoai' }
  ];
  clickActionOptions: any = [
    {
      value: true, label: 'cuon_len_dau_trang'
    },
    {
      value: false, label: 'giu_nguyen_vi_tri'
    },
    {
      value: 'scroll_to_block', label: 'cuon_den_khoi'
    }
  ]
  blocks_of_page?: any = [];
  itemEdit: any;
  listOfData: any[] = [];
  loaded
  popupHovers: any[] = [];
  hoverBlanks: any[] = [];
  /** Dùng cho hình ảnh cần nén cho các thiết bị khác nhau tối ưu SEO */
  deviceTemp: 'desktop' | 'tablet_landscape' | 'tablet_portrait' | 'mobile_landscape' | 'mobile_portrait' = 'desktop';
  /** Kích thước hình ảnh có phù hợp với kích thước thực tế hay chưa? */
  isDesignImageSizeValid: boolean = true;
  /** Có hiển thị chỗ chọn thiết bị hay không? */
  showChooseDevice: boolean = false;
  /** Chứa các kích thước thiết kế vật thể image của các thiết bị */
  imageSizeOfDevices: any = {};
  /** Biến kiểm tra obj image này có đang dùng tính năng xem toàn màn hình hay không */
  isFullscreenImage = {};
  /** Biến kiểm tra obj image này có đang dùng hiệu ứng lớp phủ hay không? Để hiển thị ô nhập nội dung */
  isEffectOverlayImage = {};
  /** Biến lưu tạm index của danh sách ảnh toàn màn hình */
  indexImgFullscreenTemp = 0;

  /**
   * Các component con trong frame repeat này, nếu là component khác thì không add
   */
  childrenComp: any = [
    'AtwTextRepeat',
    'AtwVideoRepeat',
    'AtwButtonRepeat',
    'AtwDateRepeat',
    'AtwImageRepeat',
    'AtwMapRepeat',
    'AtwPopupRepeat',
    'AtwButtonShowModalRepeat',
    'AtwImageDetailRepeat',
    'AtwTextConnectorRowRepeat',
  ]
  mapType: any = {
    'text-repeat': 'value',
    'button-repeat': 'button',
    'popup-repeat': 'popup',
  }
  sampleImgDetail = [
    "https://cdn2.cellphones.com.vn/358x358,webp,q100/media/catalog/product/t/_/t_m_18.png",
    "https://cdn2.cellphones.com.vn/358x358,webp,q100/media/catalog/product/b/_/b_c_1_9.png",
    "https://cdn2.cellphones.com.vn/358x358,webp,q100/media/catalog/product/x/_/x_m_24.png",
    "https://cdn2.cellphones.com.vn/358x358,webp,q100/media/catalog/product/b/_/b_c_1_9.png",
  ];
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  isAutoTranslate: boolean;
  useLegacy: boolean = false; // true = staticdata.data_list gốc, false = basics collection mới
  docId: string | null = null;

  constructor(
    public vhAlgorithm: VhAlgorithm,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
    private matdialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() private modal: NzModalRef,  // Thêm @Optional() vào NzModalRef
    private dialog: MatDialog,
    private languageService: LanguageService,
    public sanitizer: DomSanitizer,
    private nzModalService: NzModalService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.getSetups();
    this.getBlocksOther();
    this.getData();
  }

  // Xử lý lấy link các page về
  getBlocksOther() {
    this.vhQueryAutoWeb.getBlocks_byFields({
      type: { $in: ['popup_hover', 'hover_blank'] }
    }).then((blocks: any) => {
      if (blocks.length) {
        this.popupHovers = blocks.filter(e => e.type == 'popup_hover');
        this.hoverBlanks = blocks.filter(e => e.type == 'hover_blank');
      }
    })
  }

  getSetups() {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        if (res.length) {
          this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language')?.auto_translate_language;
        }
      })
  }

  getBlocksbyPage() {
    if (this.itemEdit.type_link == 'page_link' || this.itemEdit.type_link == 'navigation_link') {
      const link = this.itemEdit.link.replace(/^\/+/, '').split('/')[0]
      this.vhQueryAutoWeb.getPages_byFields({ link: { $eq: link } })
        .then((pages: any) => {
          if (pages.length > 0) {
            this.vhQueryAutoWeb.getBlocks_byIDpage(pages[0]._id)
              .then((res: any) => {
                this.blocks_of_page = res;
              })
          }
        })
    }
  }


  startEdit(item: any): void {
    this.itemEdit = item;
    this.isOpenModal = true;


  }


  deleteRow(id: string): void {
    const updatedList = this.listPureData.filter(d => d._id !== id);

    if (this.useLegacy) {
      this.data.staticdata.data_list = updatedList;

      this.vhQueryAutoWeb.updateObject(this.data._id, {
        staticdata: this.data.staticdata
      }).then((bool: any) => {
        this.listPureData = updatedList;
        this.listOfData = this.listOfData.filter(d => d._id !== id);
        if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
      });
    } else {
      this.vhQueryAutoWeb.updateDoc('basics', this.docId, { data_list: updatedList }).then((rsp: any) => {
        if (rsp.vcode === 0) {
          this.listPureData = updatedList;
          this.listOfData = this.listOfData.filter(d => d._id !== id);
          if (this.type == 'admin' || this.type == 'page') this.vhEventMediator.notifyOnConfigChanged({ code: this.data._id, status: 'config-changed', id_parent: this.data.id_block || this.data.id_object });
          if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        } else {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
      }, (error) => {
        console.error('updateDoc error:', error);
        this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
      });
    }
  }


  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      if (changes?.data) {
        this.getData()
      }

      if (this.itemEdit?.type == 'image-repeat' && this.isOpenModal) {
        this.isDesignImageSizeValid = await this.checkDesignImageSize();
      }
    }
  }


  handleAddData() {
    if (this.loading) return;
    this.loading = true;

    const childrenObject = this.data.objects.filter(o => this.childrenComp.includes(o.component));

    if (!childrenObject.length) {
      this.functionService.createMessage('error', 'khong_co_du_lieu_de_them');
      this.loading = false;
      return;
    }

    let itemAdd: any;
    let ordinal: number;

    if (this.listOfData.length > 0) {
      itemAdd = { ...this.listOfData[this.listOfData.length - 1] };
      itemAdd.index = itemAdd.index.split('_')[0] + '_' + (Number(itemAdd.index.split('_')[1]) + 1);
      ordinal = itemAdd.ordinal + 1;
      delete itemAdd._id;
      delete itemAdd.ordinal;
      itemAdd.sort++;

      itemAdd.data = childrenObject.reduce((obj, item, index) => {
        if (['text-repeat', 'button-repeat', 'date-repeat', 'popup-repeat'].includes(item.type)) {
          obj[item._id + '_' + ordinal] = {
            [(item.type == 'text-repeat' || item.type == 'button-repeat' || item.type == 'popup-repeat') ? 'value_' + this.functionService.selectedLanguageCode : 'value']: (item.type == 'date-repeat' ? new Date(item.staticdata.value) : item.staticdata.value),
            type: item.type,
            type_link: 'none',
            link: '',
            hyper_link: '',
            is_scroll: true,
            index: index + 1
          };
        }

        if (item.type == 'image-repeat') {
          const objTmp = {
            desktop_value: item.staticdata.value,
            tablet_landscape_value: item.staticdata.value,
            tablet_portrait_value: item.staticdata.value,
            mobile_landscape_value: item.staticdata.value,
            mobile_portrait_value: item.staticdata.value,
            desktop_value_fullscreens: [item.staticdata.value],
            tablet_landscape_value_fullscreens: [item.staticdata.value],
            tablet_portrait_value_fullscreens: [item.staticdata.value],
            mobile_landscape_value_fullscreens: [item.staticdata.value],
            mobile_portrait_value_fullscreens: [item.staticdata.value],
          };
          if (this.subproject?.style == 'app') {
            delete objTmp.desktop_value;
            delete objTmp.desktop_value_fullscreens;
          }
          obj[item._id + '_' + ordinal] = {
            ...objTmp,
            value: item.staticdata.value,
            type: item.type,
            type_link: 'none',
            link: '',
            hyper_link: '',
            is_scroll: true,
            index: index + 1
          };
        }

        if (item.type == 'video-repeat') {
          obj[item._id + '_' + ordinal] = {
            value: item.staticdata.value,
            iframe: item.staticdata.iframe,
            type: item.type,
            is_mute: false,
            loop: false,
            controls: false,
            autoplay: false,
            index: index + 1
          };
        }

        if (item.type == 'map-repeat') {
          obj[item._id + '_' + ordinal] = {
            value: item.staticdata.src,
            iframe: item.staticdata.iframe,
            default: item.staticdata.default,
            local: item.staticdata.local,
            type: item.type,
            index: index + 1
          };
        }

        if (item.type == 'image-detail-repeat') {
          obj[item._id + '_' + ordinal] = {
            desktop_value: item.staticdata.img.desktop_imgs,
            tablet_landscape_value: item.staticdata.img.tablet_landscape_imgs,
            tablet_portrait_value: item.staticdata.img.tablet_portrait_imgs,
            mobile_landscape_value: item.staticdata.img.mobile_landscape_imgs,
            mobile_portrait_value: item.staticdata.img.mobile_portrait_imgs,
            youtube_url: '',
            position_video_youtube: 1,
            type: item.type,
            type_link: 'none',
            link: '',
            hyper_link: '',
            is_scroll: true,
            index: index + 1
          };
        }

        if (item.type == 'text-connector-row-repeat') {
          obj[item._id + '_' + ordinal] = {
            ['value_start_' + this.functionService.selectedLanguageCode]: 'Văn bản bắt đầu ' + (index + 1),
            ['value_end_' + this.functionService.selectedLanguageCode]: 'Văn bản kết thúc ' + (index + 1),
            type: item.type,
            index: index + 1
          };
        }

        return obj;
      }, {});
    } else {
      ordinal = 1;
      let dataObject = {};
      if (Array.isArray(childrenObject)) {
        dataObject = childrenObject.reduce((obj, item, index) => {
          if (['text-repeat', 'button-repeat', 'date-repeat', 'popup-repeat'].includes(item.type)) {
            obj[item._id + '_' + 1] = {
              [(item.type == 'text-repeat' || item.type == 'button-repeat' || item.type == 'popup-repeat') ? 'value_' + this.functionService.selectedLanguageCode : 'value']: (item.type == 'date-repeat' ? new Date(item.staticdata.value) : item.staticdata.value),
              type: item.type,
              type_link: 'none',
              link: '',
              hyper_link: '',
              is_scroll: true,
            };
          }

          if (item.type == 'image-repeat') {
            const objTmp = {
              desktop_value: item.staticdata.value,
              tablet_landscape_value: item.staticdata.value,
              tablet_portrait_value: item.staticdata.value,
              mobile_landscape_value: item.staticdata.value,
              mobile_portrait_value: item.staticdata.value,
              desktop_value_fullscreens: [item.staticdata.value],
              tablet_landscape_value_fullscreens: [item.staticdata.value],
              tablet_portrait_value_fullscreens: [item.staticdata.value],
              mobile_landscape_value_fullscreens: [item.staticdata.value],
              mobile_portrait_value_fullscreens: [item.staticdata.value],
            };
            if (this.subproject?.style == 'app') {
              delete objTmp.desktop_value;
              delete objTmp.desktop_value_fullscreens;
            }
            obj[item._id + '_' + 1] = {
              ...objTmp,
              value: item.staticdata.value,
              type: item.type,
              type_link: 'none',
              link: '',
              hyper_link: '',
              is_scroll: true,
              index: index + 1
            };
          }

          if (item.type == 'video-repeat') {
            obj[item._id + '_' + 1] = {
              value: item.staticdata.value,
              iframe: item.staticdata.iframe,
              is_mute: false,
              loop: false,
              controls: false,
              autoplay: false,
              type: item.type,
            };
          }

          if (item.type == 'map-repeat') {
            obj[item._id + '_' + 1] = {
              value: item.staticdata.src,
              iframe: item.staticdata.iframe,
              default: item.staticdata.default,
              local: item.staticdata.local,
              type: item.type
            };
          }

          if (item.type == 'image-detail-repeat') {
            obj[item._id + '_' + 1] = {
              desktop_value: item.staticdata.img.desktop_imgs,
              tablet_landscape_value: item.staticdata.img.tablet_landscape_imgs,
              tablet_portrait_value: item.staticdata.img.tablet_portrait_imgs,
              mobile_landscape_value: item.staticdata.img.mobile_landscape_imgs,
              mobile_portrait_value: item.staticdata.img.mobile_portrait_imgs,
              youtube_url: '',
              position_video_youtube: 1,
              type: item.type,
              type_link: 'none',
              link: '',
              hyper_link: '',
              is_scroll: true,
              index: index + 1
            };
          }

          if (item.type == 'text-connector-row-repeat') {
            obj[item._id + '_' + 1] = {
              ['value_start_' + this.functionService.selectedLanguageCode]: 'Văn bản bắt đầu 1',
              ['value_end_' + this.functionService.selectedLanguageCode]: 'Văn bản kết thúc 1',
              type: item.type,
              index: index + 1
            };
          }

          return obj;
        }, {});
      }

      itemAdd = {
        index: this.data._id + '_' + 1,
        data: dataObject,
        sort: 1,
      };
    }

    itemAdd._id = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    if (this.useLegacy) {
      this.persistNewItemLegacy(itemAdd, ordinal);
    } else {
      this.persistNewItem(itemAdd, ordinal);
    }
  }

  // CÁCH CŨ: ghi vào this.data.staticdata.data_list qua updateObject
  private persistNewItemLegacy(itemAdd: any, ordinal: number) {
    this.data.staticdata.data_list = [...this.data.staticdata.data_list, itemAdd];

    this.vhQueryAutoWeb.updateObject(this.data._id, {
      staticdata: this.data.staticdata
    }).then((res) => {
      this.listPureData.push(itemAdd);

      let newData = { ...itemAdd };
      newData.data = this.convertObjectToArray(newData.data);
      newData.ordinal = ordinal;
      this.listOfData = [...this.listOfData, newData];

      if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
      this.loading = false;
    }, (error) => {
      console.error('updateObject error:', error);
      this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
      this.loading = false;
    });
  }

  // CÁCH MỚI: ghi vào collection 'basics' qua addDoc/updateDoc
  private persistNewItem(itemAdd: any, ordinal: number) {
    if (this.docId) {
      const updatedList = [...this.listPureData, itemAdd];

      this.vhQueryAutoWeb.updateDoc('basics', this.docId, { data_list: updatedList }).then((rsp: any) => {
        if (rsp.vcode === 0) {
          this.listPureData = updatedList;

          let newData = { ...itemAdd };
          newData.data = this.convertObjectToArray(newData.data);
          newData.ordinal = ordinal;
          this.listOfData = [...this.listOfData, newData];
          if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        } else {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
        this.loading = false;
      }, (error) => {
        console.error('updateDoc error:', error);
        this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        this.loading = false;
      });
    } else {
      const newDoc = {
        id_object: this.data._id,
        data_list: [itemAdd],
      };

      this.vhQueryAutoWeb.addDoc('basics', newDoc).then((rsp: any) => {
        if (rsp.vcode === 0) {
          const savedDoc = rsp.data;
          this.docId = savedDoc._id;
          this.listPureData = savedDoc.data_list || [itemAdd];

          let newData = { ...itemAdd };
          newData.data = this.convertObjectToArray(newData.data);
          newData.ordinal = ordinal;
          this.listOfData = [...this.listOfData, newData];

          if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        } else {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
        this.loading = false;
      }, (error) => {
        console.error('addDoc error:', error);
        this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        this.loading = false;
      });
    }
  }

  convertObjectToArray(data: any) {
    return Object.entries(data).map(([key, value]: [any, any]) => {
      return {
        id_ordinal: key,
        ...value
      };
    });
  }

  /**
   * Hàm chuyển đổi cấu trúc dữ liệu đầu vào.
   * Mục đích: Duyệt qua danh sách dữ liệu (rows) và ánh xạ với cấu hình đối tượng (columns)
   * để tạo ra cấu trúc dữ liệu chuẩn cho việc hiển thị (bao gồm cả dữ liệu đã lưu và dữ liệu mặc định).
   * @param data Mảng dữ liệu đầu vào cần chuyển đổi
   */
  convertData(data: any) {
    // Duyệt qua từng dòng dữ liệu (item) trong mảng đầu vào
    return data.map((item: any) => {

      // Lọc lấy các đối tượng cấu hình con (objects) hợp lệ dựa trên danh sách component cho phép
      // Sau đó map qua từng đối tượng cấu hình này để tạo dữ liệu cho từng ô (cell)
      let dataConvert = this.data.objects.filter(o => this.childrenComp.includes(o.component)).map((ele, index) => {

        // Tạo key định danh duy nhất cho ô dữ liệu: ID_cấu_hình + Số_thứ_tự_dòng
        // Ví dụ: text123_1, image456_2
        const itemIndex = ele._id + '_' + item.index.split('_')[1];

        // TRƯỜNG HỢP 1: Dữ liệu cho ô này đã tồn tại trong DB
        if (item.data.hasOwnProperty(itemIndex)) {
          return {
            id_ordinal: itemIndex, // Gán key định danh
            ...item.data[itemIndex] // Spread toàn bộ dữ liệu đã lưu
          }
        } else {
          // TRƯỜNG HỢP 2: Dữ liệu chưa tồn tại (mới thêm hoặc lỗi), cần tạo dữ liệu mặc định từ staticdata

          // Lấy tất cả các trường bắt đầu bằng 'value' từ staticdata (hỗ trợ đa ngôn ngữ value_vi, value_en...)
          const valueFields = {};
          Object.keys(ele.staticdata).forEach(key => {
            if (key.startsWith('value')) {
              valueFields[key] = ele.staticdata[key];
            }
          });

          // Khởi tạo object dữ liệu mặc định
          let valueReturn: any = {
            id_ordinal: itemIndex,
            ...valueFields,        // Gán các giá trị value đã lấy ở trên
            type: ele.type,        // Loại đối tượng
            index: index + 1,      // Thứ tự hiển thị
            type_link: 'none',     // Mặc định không có link
            link: '',
            hyper_link: '',
            is_scroll: true,
          }

          // Xử lý mặc định riêng cho loại Video
          if (ele.type == 'video-repeat') {
            valueReturn = {
              id_ordinal: itemIndex,
              value: ele.staticdata.value,
              iframe: ele.staticdata.iframe,
              is_mute: false,
              loop: false,
              controls: false,
              autoplay: false,
              type: ele.type,
              index: index + 1
            }
          }

          // Xử lý mặc định riêng cho loại Map (Bản đồ)
          if (item.type == 'map-repeat') {
            valueReturn = {
              value: item.staticdata.src,
              iframe: item.staticdata.iframe,
              default: item.staticdata.default,
              local: item.staticdata.local,
              type: item.type,
              index: index + 1
            };
          }

          // Xử lý mặc định riêng cho image-detail (Nhóm hình ảnh)
          if (item.type == 'image-detail-repeat') {
            valueReturn = {
              desktop_value: item.staticdata.img.desktop_imgs,
              tablet_landscape_value: item.staticdata.img.tablet_landscape_imgs,
              tablet_portrait_value: item.staticdata.img.tablet_portrait_imgs,
              mobile_landscape_value: item.staticdata.img.mobile_landscape_imgs,
              mobile_portrait_value: item.staticdata.img.mobile_portrait_imgs,
              youtube_url: item.staticdata.youtube_url ?? '',
              position_video_youtube: item.staticdata.position_video_youtube || 1,
              type: item.type,
              type_link: 'none',
              link: '',
              hyper_link: '',
              is_scroll: true,
              index: index + 1
            };
          }

          // Xử lý mặc định riêng cho text-connector-row
          if (item.type == 'text-connector-row-repeat') {
            valueReturn = {
              ['value_start_' + this.functionService.selectedLanguageCode]: 'Văn bản bắt đầu ' + (index + 1),
              ['value_end_' + this.functionService.selectedLanguageCode]: 'Văn bản kết thúc ' + (index + 1),
              type: item.type,
              index: index + 1
            };
          }

          return valueReturn
        }
      });

      // Trả về item đã được tái cấu trúc
      return {
        ...item,
        // Tách lấy số thứ tự dòng từ index (ví dụ: "block_1" -> 1)
        ordinal: Number(item.index.split('_')[1]),
        // Gán mảng dữ liệu chi tiết đã convert vào trường data
        data: dataConvert,
      }
    })
  }


  getData() {
    if (this.loading) return;
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(this.id_subproject);
    if (this.subproject?.style == 'app') {
      this.deviceTemp = 'tablet_portrait';
    }
    this.loading = true;

    // Chỉ coi là legacy khi data_list là mảng VÀ thực sự có phần tử bên trong
    // (mảng rỗng mặc định khi tạo frame mới không tính là legacy)
    if (Array.isArray(this.data.staticdata?.data_list) && this.data.staticdata.data_list.length > 0) {
      this.useLegacy = true;
      this.listPureData = this.data.staticdata.data_list;
      this.finishLoadData();
      return;
    }

    this.useLegacy = false;
    this.vhQueryAutoWeb.getDocs_byFields('basics', { id_object: { $eq: this.data._id } }).then((response: any) => {
      if (response.vcode === 0 && response.data?.length) {
        const doc = response.data[0];
        this.docId = doc._id;
        this.listPureData = doc.data_list || [];
      } else {
        this.docId = null;
        this.listPureData = [];
      }
      this.finishLoadData();
    }, (error: any) => {
      console.error('getDocs_byFields error:', error);
      this.loading = false;
    });
  }

  private finishLoadData() {
    this.listOfData = this.convertData(this.listPureData);

    this.showChooseDevice = this.listOfData?.[0]?.data.some(
      i => ['image-repeat', 'image-detail-repeat'].includes(i.type)
    ) || false;

    this.vhAlgorithm.sortNumberbyASC(this.listOfData, 'sort');
    this.loading = false;
    this.getLinkAllPages();
  }

  updateOrdinal(dataRow) {
    const updatedList = this.listPureData.map(item =>
      item._id === dataRow._id ? { ...item, sort: Number(dataRow.sort) } : item
    );

    if (this.useLegacy) {
      this.data.staticdata.data_list = updatedList;

      this.vhQueryAutoWeb.updateObject(this.data._id, {
        staticdata: this.data.staticdata
      }).then((res) => {
        this.listPureData = updatedList;
        if (res) this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
      });
    } else {
      this.vhQueryAutoWeb.updateDoc('basics', this.docId, { data_list: updatedList }).then((rsp: any) => {
        if (rsp.vcode === 0) {
          this.listPureData = updatedList;
          if (this.type == 'admin' || this.type == 'page') this.vhEventMediator.notifyOnConfigChanged({ code: this.data._id, status: 'config-changed', id_parent: this.data.id_block || this.data.id_object });
          this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        } else {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
      }, (error) => {
        console.error('updateDoc error:', error);
      });
    }
  }

  updateVideoRepeat(field, value) {
    // Tách URL gốc ra từ iframe
    const iframeSrc = this.itemEdit.iframe;

    // Trường hợp link là youtube
    if (iframeSrc.includes('youtube.com') || iframeSrc.includes('youtube-nocookie.com')) {
      const urlMatch = iframeSrc.match(/src="([^"]+)"/);
      if (!urlMatch) return;

      const url = new URL(urlMatch[1]);

      // ⚙️ Cập nhật query params theo từng trường
      if (field === 'is_mute') {
        if (value) {
          url.searchParams.set('mute', '1');
          url.searchParams.set('autoplay', '1'); // mute phải đi với autoplay
        } else {
          url.searchParams.delete('mute');
          if (!this.itemEdit.autoplay) {
            url.searchParams.delete('autoplay');
          }
        }
      }

      if (field === 'loop') {
        if (value) {
          url.searchParams.set('loop', '1');
        } else {
          url.searchParams.delete('loop');
        }
      }

      if (field === 'controls') {
        if (value) {
          url.searchParams.set('controls', '1');
        } else {
          url.searchParams.set('controls', '0');
        }
      }

      if (field === 'autoplay') {
        if (value) {
          url.searchParams.set('autoplay', '1');
          if (!this.itemEdit.is_mute) {
            // Nếu không mute mà vẫn bật autoplay, thì có thể không hoạt động trên Chrome
            console.warn('Autoplay có thể không hoạt động nếu không mute');
          }
        } else {
          url.searchParams.delete('autoplay');
        }
      }

      // Chuyển đổi link youtube thường sang link nocookie
      const newSrc = url.toString().includes("youtube.com/embed")
        ? url.toString().replace("youtube.com", "youtube-nocookie.com")
        : url.toString();
      // ⚡ Gán lại vào iframe HTML
      this.itemEdit.iframe = this.itemEdit.iframe.replace(/src="([^"]+)"/, `src="${newSrc}"`);

      // Cập nhật value riêng nếu cần
      this.itemEdit.value = newSrc;
    }
    // Trường hợp link là tiktok
    else if (iframeSrc.includes('tiktok.com')) {
      this.getLinkTiktok(this.itemEdit.iframe);
    }
    // Trường hợp link là facebook
    else if (iframeSrc.includes('facebook.com')) {
      this.getLinkFacebook(this.itemEdit.iframe);
    }
    // Trường hợp link là instagram
    else if (iframeSrc.includes('instagram.com')) {
      this.getLinkInstagram(this.itemEdit.iframe);
    }
  }

  /**
   * Hàm này sẽ lấy link tiktok mà người dùng nhúng vào
   */
  private getLinkTiktok(link: any) {
    try {
      const cleanInput = link.trim();

      // 1. Trường hợp link rút gọn từ App điện thoại (vt.tiktok.com hoặc vm.tiktok.com)
      if (cleanInput.includes('vt.tiktok.com') || cleanInput.includes('vm.tiktok.com')) {
        this.handleAppShortLink(cleanInput);
        return;
      }

      // 2. Trường hợp copy nguyên cục mã nhúng blockquote (có chứa data-video-id)
      if (cleanInput.includes('data-video-id=')) {
        const matchId = cleanInput.match(/data-video-id="(\d+)"/);
        if (matchId && matchId[1]) {
          this.updateTiktokSrc(matchId[1]);
          return;
        }
      }

      // 3. Trường hợp link Web thông thường (Trích xuất ID trực tiếp)
      const videoId = this.extractIdFromWebUrl(cleanInput);
      if (videoId) {
        this.updateTiktokSrc(videoId);
      } else {
        console.error('Không tìm thấy ID video TikTok hợp lệ');
      }
    } catch (error) {
      this.functionService.createMessage('error', 'vui_long_lam_theo_huong_dan_de_lay_duoc_duong_dan_chinh_xac');
    }
  }

  /**
   * Xử lý trích xuất ID từ URL Web (dùng Regex)
   */
  private extractIdFromWebUrl(url: string): string | null {
    const regex = /\/(?:video|embed\/v2|embed)\/(\d+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  /**
   * Xử lý link rút gọn từ App (Cần gọi qua một proxy/backend)
   */
  private handleAppShortLink(shortUrl: string): void {
    // Gọi qua API của unshorten.me công cộng
    const apiUrl = `https://unshorten.me/json/${encodeURIComponent(shortUrl)}`;

    this.http.get<{ resolved_url: string, success: boolean }>(apiUrl).subscribe({
      next: (res) => {
        if (res.success && res.resolved_url) {
          const videoId = this.extractIdFromWebUrl(res.resolved_url);
          if (videoId) {
            this.updateTiktokSrc(videoId);
            return;
          }
        }
      },
      error: (err) => {
        console.error('Lỗi API Unshorten:', err);
      }
    });
  }

  /**
   * Tạo link tiktok để gán vào staticdata
   */
  private updateTiktokSrc(videoId: string): void {
    this.itemEdit.value = `
      <blockquote class="tiktok-embed" data-video-id="${videoId}" style="max-width: 605px; min-width: 325px; width: 100%; height: 100%;">
        <section></section>
      </blockquote>
      <script async src="https://www.tiktok.com/embed.js"></script>
    `;
  }

  // Hàm cốt lõi để xử lý chuỗi
  private getLinkFacebook(input: string) {
    // TRƯỜNG HỢP 1: Nếu đầu vào là một đoạn mã <iframe>, ta trích xuất nội dung trong thuộc tính src
    if (input.includes('<iframe')) {
      const srcMatch = input.match(/src="([^"]+)"/);
      this.itemEdit.value = srcMatch ? srcMatch[1] : '';
    }
    // TRƯỜNG HỢP 2: Nếu đầu vào là link share thông thường (bản chất là link rút gọn của FB)
    else if (input.includes('facebook.com')) {
      // Mã hóa link gốc để đưa vào tham số href của plugin Facebook
      const encodedUrl = encodeURIComponent(input);
      this.itemEdit.value = `https://www.facebook.com/plugins/video.php?href=${encodedUrl}&show_text=false`;
    }
  }

  /**
   * Hàm cốt lõi: Biến đổi mọi loại chuỗi Instagram thành Link Embed an toàn
   * @param input Chuỗi link gốc hoặc đoạn mã Blockquote bài viết
   */
  private getLinkInstagram(input: string) {
    // Regex tìm kiếm ID bài viết sau các cụm /p/, /reel/, hoặc /tv/
    const regex = /\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/;
    const match = input.match(regex);

    if (match && match[1]) {
      const videoId = match[1];
      // Tạo link embed chuẩn sạch
      this.itemEdit.value = `https://www.instagram.com/p/${videoId}/embed/`;
    }
  }

  updateData(dataRow) {
    const foundItem = this.listPureData.find(item => item._id === dataRow._id);
    if (!foundItem) return;

    // Gộp toàn bộ itemEdit vào ô dữ liệu hiện có (không chỉ các trường bắt đầu bằng 'value')
    foundItem.data[this.itemEdit.id_ordinal] = {
      ...foundItem.data[this.itemEdit.id_ordinal],
      ...this.itemEdit
    };

    const updatedList = this.listPureData.map(item =>
      item._id === dataRow._id ? foundItem : item
    );

    if (this.useLegacy) {
      this.data.staticdata.data_list = updatedList;

      this.vhQueryAutoWeb.updateObject(this.data._id, {
        staticdata: this.data.staticdata
      }).then((res: any) => {
        if (res?.vcode === 0 || res === true) {
          this.listPureData = updatedList;
          this.listOfData = this.convertData(this.listPureData);
          this.vhAlgorithm.sortNumberbyASC(this.listOfData, 'sort');
          if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        } else {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
      }, (error) => {
        console.error('updateObject error:', error);
        this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
      });
    } else {
      if (!this.docId) {
        console.error('updateData: docId is null, cannot updateDoc on basics collection');
        this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        return;
      }

      this.vhQueryAutoWeb.updateDoc('basics', this.docId, { data_list: updatedList }).then((rsp: any) => {
        if (rsp.vcode === 0) {
          this.listPureData = updatedList;
          this.listOfData = this.convertData(this.listPureData);
          this.vhAlgorithm.sortNumberbyASC(this.listOfData, 'sort');
          if (this.type == 'admin' || this.type == 'page') this.vhEventMediator.notifyOnConfigChanged({ code: this.data._id, status: 'config-changed', id_parent: this.data.id_block || this.data.id_object });
          if (this.functionService.getTypeConfig() == 'admin') this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        } else {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
      }, (error) => {
        console.error('updateDoc error:', error);
        this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
      });
    }
  }

  onUpload(e, dataRow, type = 'img') {
    const file = e.target.files[0];

    if (file) {
      let compressType = this.compressType
      let resolution = {};

      if (compressType == 'compress-frame') {
        resolution = this.imageSizeOfDevices[this.deviceTemp];
      }
      else if (compressType == 'custom') {
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        }
        compressType = 'compress-frame';
      }
      this.vhImage
        .getImageFromDesktop_Autoweb(
          file,
          'images/design/objects',
          {
            compress_type: compressType,
            resolution: resolution,
          }
        )
        .then(
          (rsp: any) => {
            console.log('rsp', rsp);
            if (rsp.vcode === 0) {
              if (this.isSharedImg) {
                this.itemEdit.value = rsp.data;
                this.functionService.devices.map(d => {
                  if (type == 'img') {
                    this.itemEdit[`${d.value}_value`] = rsp.data;
                  } else if (type == 'fullscreen') {
                    this.itemEdit[`${d.value}_value_fullscreens`].push(rsp.data);
                  }
                });
              }
              else {
                if (type == 'img') {
                  this.itemEdit[this.deviceTemp + '_value'] = rsp.data;
                } else if (type == 'fullscreen') {
                  this.itemEdit[this.deviceTemp + '_value_fullscreens'].push(rsp.data);
                }
                // Này để khởi tạo giá trị ban đầu
                if (this.deviceTemp == 'desktop') {
                  this.itemEdit.value = rsp.data;
                }
              }
              this.updateData(dataRow)
            } else {
              this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${rsp.msg}`);
            }
          },
          (error) => {
            console.error(error);
          }
        )
        .catch((error) => {
          console.error(error);
        })
    }
  }

  path = ''; // Nên để rỗng vì ban đâu sẽ đi vào thư mục /images/design/objects
  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary(dataRow, type = 'fullscreen') {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path || '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        if (this.isSharedImg) {
          this.itemEdit.value = data.href;
          this.functionService.devices.map(d => {
            if (type == 'img') {
              this.itemEdit[`${d.value}_value`] = data.href;
            } else if (type == 'fullscreen') {
              this.itemEdit[`${d.value}_value_fullscreens`].push(data.href);
            }
          });
        }
        else {
          if (type == 'img') {
            this.itemEdit[this.deviceTemp + '_value'] = data.href;
          } else if (type == 'fullscreen') {
            this.itemEdit[this.deviceTemp + '_value_fullscreens'].push(data.href);
          }
          // Này để khởi tạo giá trị ban đầu
          if (this.deviceTemp == 'desktop') {
            this.itemEdit.value = data.href;
          }
        }
        this.updateData(dataRow)
      }
      this.path = data.path;
    });
  }

  openFreeImage(dataRow, type = 'fullscreen') {
    const dialogRef = this.matdialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.isSharedImg) {
          this.itemEdit.value = result;
          this.functionService.devices.map(d => {
            if (type == 'img') {
              this.itemEdit[`${d.value}_value`] = result;
            } else if (type == 'fullscreen') {
              this.itemEdit[`${d.value}_value_fullscreens`].push(result);
            }
          });
        }
        else {
          if (type == 'img') {
            this.itemEdit[this.deviceTemp + '_value'] = result;
          } else if (type == 'fullscreen') {
            this.itemEdit[this.deviceTemp + '_value_fullscreens'].push(result);
          }
          // Này để khởi tạo giá trị ban đầu
          if (this.deviceTemp == 'desktop') {
            this.itemEdit.value = result;
          }
        }
        this.updateData(dataRow)
      }
    });
  }

  async chooseItemEdit(item, dataRow): Promise<void> {
    this.itemEdit = item;
    this.itemEdit.scroll_distance = this.itemEdit.scroll_distance || 0;
    this.dataRow = dataRow;

    if (item.type != 'image-detail-repeat')
      this.isOpenModal = true;

    if (item.type == 'image-repeat') {
      // Lấy ra kích thước thiết kế để dùng cho các hàm
      this.getDesignDimensionsOfDevices(item);

      // Khởi tạo device + value nếu chưa có
      this.functionService.devices.forEach((d) => {
        this.isFullscreenImage[d.value] = this.checkImgHasFullscreen(item, d.value);
        this.itemEdit[`${d.value}_value`] ??= 'assets/patterns/ImageComponent/green-tree.png';
        if (this.itemEdit[`${d.value}_value_fullscreen`]) {
          this.itemEdit[`${d.value}_value_fullscreens`] ??= [this.itemEdit[`${d.value}_value_fullscreen`]];
        } else {
          this.itemEdit[`${d.value}_value_fullscreens`] ??= ['assets/patterns/ImageComponent/green-tree.png'];
        }

        this.isEffectOverlayImage[d.value] = this.checkImgHasEffectOverlay(item, d.value);
      });

      // Kiểm tra nút cập nhật size ảnh theo size thiết kế có cần hiển thị hay không
      this.isDesignImageSizeValid = await this.checkDesignImageSize();
    }

    if (item.type == 'map-repeat') {
      this.radioValue = item.local != '' ? 'location' : 'iframe';
    }

    if (item.type == 'image-detail-repeat') {
      // Lấy ra kích thước thiết kế để dùng cho các hàm
      this.getDesignDimensionsOfDevices(item);

      // Khởi tạo device + value nếu chưa có
      this.functionService.devices.forEach((d) => {
        this.itemEdit[`${d.value}_value`] ??= this.sampleImgDetail;
      });
      this.itemEdit.youtube_url ??= '';
      this.itemEdit.position_video_youtube ??= 1;

      const modal: NzModalRef = this.nzModalService.create({
        nzTitle: this.languageService.translate('danh_sach_hinh_anh'),
        nzWidth: '90%',
        nzContent: AtwImageDetailRepeatAdmin,
        nzComponentParams: {
          data: {
            type: item.type,
            type_link: 'none',
            link: '',
            hyper_link: '',
            is_scroll: true,
          },
          dataRow: dataRow,
          itemEdit: this.itemEdit,
          isSharedImg: this.isSharedImg,
          sourceImg: this.source,
          sources: this.sources,
          device: this.deviceTemp,
          compressType: this.compressType,
          compressWidth: this.compressWidth,
          compressHeight: this.compressHeight,
          arr_link_page: this.arr_link_page,
          dimension: {
            desktop: this.imageSizeOfDevices.desktop,
            tablet_landscape: this.imageSizeOfDevices.tablet_landscape,
            tablet_portrait: this.imageSizeOfDevices.tablet_portrait,
            mobile_landscape: this.imageSizeOfDevices.mobile_landscape,
            mobile_portrait: this.imageSizeOfDevices.mobile_portrait,
          },
        },
        nzFooter: null,
      });

      modal.afterClose.subscribe(result => {
        if (result) {
          this.updateData(result);
        }
      });
    }

    if (item.type != 'image-detail-repeat') {
      this.getBlocksbyPage()
    }
  }

  openUploadToServer() {
    this.isShowUploadToServer = true;
  }

  /**
 * Xử lý lấy link các page về.
 */
  getLinkAllPages() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $in: ['blank', 'homepage'] } }).then((pages: any) => {
      this.arr_link_page = pages.map((page) => {
        // if (!page.name) console.warn('Không có name', page)
        if (!page['name_' + this.functionService.selectedLanguageCode] && page.name) {
          return {
            ...page,
            ['name_' + this.functionService.selectedLanguageCode]: page.name
          };
        } else return page;
      });
      this.arr_link_page = this.vhAlgorithm.sortVietnamesebyASC(this.arr_link_page, 'name_' + this.functionService.selectedLanguageCode);
      // this.arr_link_page = pages;
    });
  }

  // remove link khi click vào nút x
  removeLink(fieldName: string) {
    this.itemEdit[fieldName] = '';
  }




  findObjectName(item: any): string {
    const objectId = item.id_ordinal.split('_')[0];
    const foundObject = this.data.objects.find(object => object._id === objectId);
    return foundObject ? foundObject.name : '';
  }


  /**
   * Hàm mở ra hộp thoại chỉnh sửa tên và update 
   * @param object 
   */
  editNameObject(object: any) {
    this.matdialog
      .open(EditNameComponent, {
        width: '20%',
        data: object.name || this.data.name,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.data.name = result;
          this.updateObject();
        }
      });
  }


  /**
   * Update dữ liệu của data
   */
  updateObject() {
    if (this.functionService.getTypeConfig() == 'admin') {
      if (!this.data.hasOwnProperty('fieldUpdate')) this.data['fieldUpdate'] = []
      if (!this.data['fieldUpdate'].includes('name')) this.data['fieldUpdate'].push('name')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.data._id, { name: this.data.name })
      .then((bool) => {
        // console.log('bool', bool);
      },
        (error) => {
          console.log('error', error);
          this.functionService.createMessage('error', 'Cập nhật dữ liệu thất bại !!!');
        }
      );
  }

  cancelUploadToServer() {
    this.isShowUploadToServer = false;
  }

  okUploadToServer(itemEdit, type = 'img', index = 0) {
    this.uploadToServerLoading = true;
    let compressType = this.compressType;
    let resolution = {};

    if (compressType == 'compress-frame') {
      resolution = this.imageSizeOfDevices[this.deviceTemp];
    }
    else if (compressType == 'custom') {
      resolution = {
        width: +this.compressWidth,
        height: +this.compressHeight,
      };
      compressType = 'compress-frame';
    }

    if (type == 'fullscreen') {
      const res = this.functionService.devices.find(d => d.value == this.deviceTemp);
      resolution = {
        width: res.width,
        height: res.height,
      };
      compressType = 'compress-screen';
    }
    const value = type == 'img'
      ? (itemEdit[`${this.deviceTemp}_value`] || itemEdit.value)
      : itemEdit[`${this.deviceTemp}_value_fullscreens`][index];

    this.vhImage
      .getImageFromURL_Autoweb(
        value,
        'images/design/objects',
        {
          compress_type: compressType,
          resolution: resolution,
        }
      )
      .then((res: any) => {
        if (res.vcode != 0) {
          console.error(res.msg);
          this.functionService.createMessage('error', res.msg, 5000);
          this.isShowUploadToServer = false;
          return;
        }

        if (this.isSharedImg) {
          itemEdit.value = res.data;
          this.functionService.devices.map(d => {
            if (type == 'img') {
              itemEdit[`${d.value}_value`] = res.data;
            } else if (type == 'fullscreen') {
              itemEdit[`${d.value}_value_fullscreens`][index] = res.data;
            }
          });
        }
        else {
          if (type == 'img') {
            itemEdit[this.deviceTemp + '_value'] = res.data;
          } else if (type == 'fullscreen') {
            itemEdit[this.deviceTemp + '_value_fullscreens'][index] = res.data;
          }
          // Này để khởi tạo giá trị ban đầu
          if (this.deviceTemp == 'desktop') {
            itemEdit.value = res.data;
          }
        }
        this.updateData(this.dataRow)
        this.isShowUploadToServer = false;
      })
      .catch((error) => {
        console.error(error);
        if (error.message && error.message.includes('413')) {
          // Thông báo cho người dùng
          this.functionService.createMessage('error', 'file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb');
        }
      })
      .finally(() => this.uploadToServerLoading = false);
  }

  openDialogChooseIcon() {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.itemEdit.icon_name = result.icon;
        this.updateData(this.dataRow)
      }
    });
  }

  onDateTimeChange(result, item): void {
    this.itemEdit = item;
    if (result instanceof Date && !isNaN(result.getTime())) {
      item.value = result;
      this.itemEdit.value = result.toISOString();
    } else {
      item.value = new Date('2025-05-19 14:30:00');
    }
  }

  onDateTimeOk(result, dataRow) {
    this.updateData(dataRow);
  }

  /**
   * Khi chọn add link bằng iframe hàm này sẽ cập nhật
   * @param item
   * @param dataRow
   */
  getLink_atwMapRepeat(item, dataRow) {
    try {
      const link = item.iframe;
      const linkSplit = link.split(/(https.*?")/).filter(Boolean);
      const srcVideo = linkSplit[1].replace('"', '');
      const regex = /^https:\/\/www\.google\.com\/maps\/embed\?pb=.+$/;
      const videoId = srcVideo.match(regex);
      if (link.includes('iframe') && link.includes('map') && videoId) {
        item.local = "";
        item.value = srcVideo;
        item.default = true;
        item.iframe = link;
        this.functionService.createMessage('success', 'cap_nhat_duong_dan_ban_do_thanh_cong');

        // this.vhEventMediator.notifyOnConfigChanged({
        //   id: this.objectChoosing._id,
        //   updateIframe: true,
        // });
      } else {
        this.functionService.createMessage('error', 'duong_dan_sai_vui_long_doc_huong_dan_chen_ban_do_de_lay_duong_dan_dung');
      }
      this.updateData(dataRow);
    } catch (error) {
      this.functionService.createMessage('warning', 'vui_long_lam_theo_huong_dan_de_lay_duoc_duong_dan_chinh_xac');
    }
  }

  /**
   * Khi chọn add link bằng địa chỉ hàm này sẽ được gọi ra
   * @param item 
   * @param dataRow
   */
  getLocal_atwMapRepeat(item, dataRow) {
    // Đầu tiên sẽ xóa khoảng trắng thừa của chuỗi (vd : 1   6    1  N i Sư Huỳnh L iên => 161NiSưHuỳnhLiên)
    const local = item.local.replace(/\s/g, '');
    if (local.length > 0) {
      item.value = this.getGoogleMapsUrl(local)
      item.default = true;
      item.local = local
      this.updateData(dataRow);
    } else {
      this.functionService.createMessage('warning', 'vi_tri_khong_duoc_de_trong_hoac_dung_cach_nhung_ban_do_neu_khong_dung_vi_tri');
    }
  }

  /**
   * hàm này sẽ chuyển địa chỉ thành chuỗi url
   * @param place Dịa chi
   * @returns 
   */
  private getGoogleMapsUrl(place: string) {
    const query = {
      q: place
    };

    const url = 'https://www.google.com/maps?' + this.encodeQueryData(query);

    return url + "&output=embed"
  }

  /**
   * Hàm này sẽ mã hóa chuỗi url địa chỉ
   * @param data Dữ liệu
   * @returns 
   */
  private encodeQueryData(data: any) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  }

  /**
   * Hàm kiểm tra giá trị truyền vào
   * @param { mailto, tel }
   * @returns boolean
   */
  isValidValue({ mailto, tel }: { mailto?: string; tel?: string } = {}): boolean {
    const patterns: any = {
      // mailto: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      mailto: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/i,
      // tel: /^((0|\+84)(3[2-9]|5[2689]|7[06-9]|8[1-689]|9[0-46-9])[0-9]{7}|(1800|1900)[0-9]{4})$/,
    };

    if (mailto) return patterns.mailto.test(mailto);
    // if (tel) return patterns.tel.test(tel);
    if (tel) return true;

    return true;
  }

  /**
   * Hàm lấy kích thước thiết kế của hình ảnh trong khung lưới
   * @param item 
   */
  private getDesignDimensionsOfDevices(item) {
    const idObj = item.id_ordinal.split('_')[0];
    const obj = this.data.objects.find(object => object._id === idObj);
    this.functionService.devices.forEach((d) => {
      this.imageSizeOfDevices[d.value] = {}; // Reset giá trị cũ

      // Trường hợp dimension đã có dữ liệu
      if (
        obj?.[`${d.value}_config`]?.dimension?.width &&
        obj?.[`${d.value}_config`]?.dimension?.height
      ) {
        this.imageSizeOfDevices[d.value] = obj[`${d.value}_config`].dimension;
      }
      // Trường hợp type là image-repeat 
      // Và chưa có dimension thì dùng của class image
      else if (
        item.type == 'image-repeat' &&
        obj[`${d.value}_class`]?.image?.width &&
        obj[`${d.value}_class`]?.image?.height
      ) {
        const container = obj[`${d.value}_class`].image;
        this.imageSizeOfDevices[d.value] = {
          width: parseFloat(container.width),
          height: parseFloat(container.height)
        }
      }
      // Trường hợp type là image-detail-repeat 
      // Và chưa có dimension thì dùng của class image-detail
      else if (
        item.type == 'image-detail-repeat' &&
        obj[`${d.value}_class`]?.['image-detail']?.width &&
        obj[`${d.value}_class`]?.['image-detail']?.height
      ) {
        const container = obj[`${d.value}_class`]['image-detail'];
        this.imageSizeOfDevices[d.value] = {
          width: parseFloat(container.width),
          height: parseFloat(container.height)
        }
      }
    });
  }

  /**
   * Lấy ra tên file và đuôi file
   * @param url Đường dẫn ảnh
   * @example const { fileName, fileExtension } = getFileInfo("https://115.78.228.208:20350/autowebapp/67c1b593b1344364462b082b/images/design/objects/3-1-768x768%20(3).png");
   */
  getFileInfo(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const parts = decodedUrl.split('/');

    // Lấy tên file (phần cuối)
    const fullFileName = parts.pop() || '';
    const dotIndex = fullFileName.lastIndexOf('.');

    // Tìm và lấy phần giữa (ví dụ: "images/design/objects")
    const indexImages = parts.indexOf('images');
    const folderPath =
      indexImages !== -1 ? parts.slice(indexImages).join('/') : '';

    return {
      fullFileName, // ví dụ: "3-1-768x768 (3).png"
      fileName: fullFileName.substring(0, dotIndex), // "3-1-768x768 (3)"
      fileExtension: fullFileName.substring(dotIndex + 1), // "png"
      folderPath, // "images/design/objects"
    };
  }

  /** Hàm kiểm tra có cần phải hiển thị nút cập nhật không */
  private async checkDesignImageSize() {
    // chạy song song cho nhanh
    const results = await Promise.all(this.functionService.devices.map(async d => {
      // Trường hợp itemEdit device value chưa có thì gán tạm
      this.itemEdit[`${d.value}_value`] ??= this.itemEdit.value;

      // Nếu giao diện thiết kế đã ẩn thiết bị thì không cần check
      if (!this.subproject?.[`${d.value}_template_display`]) {
        return false;
      }
      // Ảnh gốc
      const url = this.itemEdit[`${d.value}_value`];
      const imgSize = await this.functionService.getImageSize(url);
      // Container thiết kế
      const containerSize = this.imageSizeOfDevices[d.value]

      return this.functionService.checkRatioDesignImgSize(imgSize, containerSize);
    }));

    // chỉ cần 1 device trả về true → return true
    return results.some(v => v === true);
  }

  /**
   * Hàm update kích thước ảnh phù hợp cho từng kích thước thiết kế của từng thiết bị
   * @param itemEdit
   * @param dataRow
   */
  async updateDesignImageSize(itemEdit, dataRow) {
    const messages: { type: 'success' | 'warning' | 'error', msg: string, duration?: number }[] = [];

    // ⭐ Show Loading 1 lần duy nhất
    await this.functionService.showLoading("", "current-loading", null, 0, false);

    await Promise.all(
      this.functionService.devices.map(async d => {
        // Trường hợp itemEdit device value chưa có thì gán tạm
        this.itemEdit[`${d}_value`] ??= this.itemEdit.value;

        // Nếu giao diện thiết kế đã ẩn thiết bị thì không cần check
        if (!this.subproject[`${d.value}_template_display`]) return;

        /** Khai báo tin nhắn thông báo cho từng thiết bị */
        const msgDevices = `(${this.languageService.translate('thiet_bi')} ${this.languageService.translate(d.label)}) ${this.findObjectName(itemEdit)}: `;

        // Ảnh gốc
        const url = itemEdit[`${d.value}_value`];

        // Trường hợp đường dẫn không có hoặc rỗng
        if (!url) {
          messages.push({
            type: 'warning',
            msg: msgDevices + this.languageService.translate('chua_truyen_duong_dan_anh')
          });
          return;
        }

        // Trường hợp chưa up lên server đây là bước bắt buộc 
        // vì cần phải giữ một ảnh gốc để sau này có resize ảnh thì còn cần ảnh gốc để nén lại
        if (!url.includes(this.id_subproject)) {
          messages.push({
            type: 'warning',
            msg: msgDevices + this.languageService.translate('anh_nay_chua_chuyen_len_server')
          });
          return;
        }

        const imgSize = await this.functionService.getImageSize(url);

        // Container thiết kế
        const containerSize = this.imageSizeOfDevices[d.value];

        // Trường hợp nếu ảnh này đã phù hợp thì trả về thông báo chứ không update nữa
        if (!this.functionService.checkRatioDesignImgSize(imgSize, containerSize)) {
          messages.push({
            type: 'warning',
            msg: msgDevices + this.languageService.translate('anh_nay_da_phu_hop_khong_can_cap_nhat_nua')
          });
          return;
        }

        const msgSolution = this.functionService.getTypeConfig() == 'admin'
          ? 'vui_long_chuan_bi_mot_hinh_khac_phu_hop'
          : 'vui_long_sua_thiet_ke_hoac_chuan_bi_mot_hinh_khac_phu_hop';

        // Trường hợp đã cập nhật hoặc width là bằng sẵn rồi nhưng height thiết kế không phù hợp
        // Thì trả về thông báo chứ không cho update nữa vì gây tăng dung lượng lưu ảnh không cần thiết
        if (
          imgSize.width == containerSize.width &&
          imgSize.height != containerSize.height
        ) {
          const mTmp = containerSize.height > imgSize.height
            ? 'chieu_cao_thiet_ke_lon_hon_chieu_cao_anh'
            : 'chieu_cao_thiet_ke_nho_hon_chieu_cao_anh';
          const m = this.languageService.translate(mTmp) + '. ' + this.languageService.translate(msgSolution);
          messages.push({
            type: 'error',
            msg: msgDevices + m + '!!!',
            duration: 8000
          });
          return;
        }

        // Trường hợp nếu ảnh này bé hơn kích thước thiết kế thì báo cho người dùng và không cập nhật
        if (imgSize.width < containerSize.width) {
          const mTmp = 'chieu_dai_anh_nho_hon_chieu_dai_thiet_ke_lam_cho_viec_nen_anh_theo_khung_hien_thi_hinh_anh_khong_hoat_dong';
          const m = this.languageService.translate(mTmp) + '. ' + this.languageService.translate(msgSolution);
          messages.push({
            type: 'error',
            msg: msgDevices + m + '!!!',
            duration: 8000
          });
          return;
        }

        // Cập nhật ảnh cho từng thiết bị
        try {
          const rsp: any = await this.vhImage.getImageFromURL_Autoweb(
            url,
            'images/design/objects',
            {
              compress_type: 'compress-frame',
              resolution: containerSize,
            }
          );

          if (rsp.vcode == 0) {
            itemEdit[`${d.value}_value`] = rsp.data;
            if (d.value == 'desktop') {
              itemEdit.value = rsp.data;
            }

            messages.push({
              type: 'success',
              msg: msgDevices + this.languageService.translate('tai_anh_thanh_cong')
            });
          } else {
            messages.push({
              type: 'error',
              msg: msgDevices + this.languageService.translate('tai_anh_that_bai_ly_do') + rsp.msg
            });
          }
        } catch (error: any) {
          if (error.message?.includes('413')) {
            messages.push({
              type: 'error',
              msg: msgDevices + this.languageService.translate('file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb')
            });
          }
        }
      })
    );

    // CHỈ CHẠY SAU KHI HOÀN TẤT TẤT CẢ DEVICE
    this.updateData(dataRow);

    // ⭐ Hide loading (delay 200ms để tránh flick)
    await this.functionService.hideLoading(200);

    // Show toàn bộ message sau cùng
    messages.forEach(m => {
      this.functionService.createMessage(m.type, m.msg, m.duration ?? 5000);
    });
  }

  /**
   * Sao chép đường dẫn hình ảnh vào bộ nhớ tạm
   */
  copyLinkImg(text?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const textCopy = text || this.itemEdit[this.deviceTemp + '_value'];
      navigator.clipboard.writeText(textCopy)
        .then(() => {
          this.functionService.createMessage('success', 'da_sao_chep_vao_bo_nho_tam', 2000);
        })
        .catch(err => {
          this.functionService.createMessage('error', 'loi_khi_sao_chep', 2000);
          console.error('❌ Lỗi khi copy:', err);
        });
    }
  }

  handleLinkImg(dataRow, type = 'img') {
    if (this.isSharedImg) {
      this.functionService.devices.map(d => {
        if (type == 'img') {
          this.itemEdit[`${d.value}_value`] = this.itemEdit.value;
        } else if (type == 'fullscreen') {
          this.itemEdit[`${d.value}_value_fullscreens`].push(this.itemEdit.value_fullscreen);
        }
      });
    }
    else {
      if (type == 'img') {
        this.itemEdit[this.deviceTemp + '_value'] = this.itemEdit.value;
      } else if (type == 'fullscreen') {
        this.itemEdit[this.deviceTemp + '_value_fullscreens'].push(this.itemEdit.value_fullscreen);
      }
    }
    this.updateData(dataRow);
  }

  /**
   * Hàm kiểm tra xem obj img này có đang dùng tính năng xem toàn màn hình hay không. 
   * Để xem có hiển thị ô nhập hay không
   */
  checkImgHasFullscreen(item, device) {
    const idObj = item.id_ordinal.split('_')[0];
    const obj = this.data.objects.find(object => object._id === idObj);
    return obj[device + '_config']?.['image-fullscreen']?.['toggle_fullscreen'] || false;
  }

  /**
   * Hàm kiểm tra xem obj img này có đang dùng hiệu ứng lớp phủ hay không. 
   * Để xem có hiển thị ô nhập hay không
   */
  checkImgHasEffectOverlay(item, device) {
    const idObj = item.id_ordinal.split('_')[0];
    const obj = this.data.objects.find(object => object._id === idObj);
    if (obj.staticdata?.[device + '_animation_type'] == 'none')
      return false;
    return obj.staticdata?.[device + '_animation']?.['animation-0']?.['--0b-content-used-name'] || false;
  }

  /**
   * Hàm kéo thả thay đổi thứ tự ảnh trong danh sách ảnh toàn màn hình
   */
  dropImgFullscreens(event: CdkDragDrop<string[]>, dataRow) {
    const arrayKey = this.deviceTemp + '_value_fullscreens';
    // Di chuyển phần tử trong mảng thực tế
    moveItemInArray(
      this.itemEdit[arrayKey],
      event.previousIndex,
      event.currentIndex
    );

    this.updateData(dataRow);
  }

  /**
   * Hàm xoá ảnh thứ tự bất kì trong danh sách ảnh toàn màn hình
   */
  handleDelImgFullscreens(dataRow, index = 0) {
    if (this.isSharedImg) {
      this.functionService.devices.map(d => {
        this.itemEdit[`${d.value}_value_fullscreens`].splice(index, 1);
      });
    }
    else {
      this.itemEdit[this.deviceTemp + '_value_fullscreens'].splice(index, 1);
    }
    this.updateData(dataRow);
  }

  async autoTranslateLang(field, itemEdit, dataRow) {
    if (!this.isAutoTranslate) return;

    const content = itemEdit[`${field}_${this.functionService.languageTempCode}`]?.trim();
    if (!content) return;

    const typeObject = itemEdit.type;
    const objValueMap = {
      'image-repeat': 'hieu_ung',
      'text-repeat': 'tieu_de',
      'button-repeat': 'nut',
      'popup-repeat': 'nut',
    }

    const messageMap = {
      value: 'noi_dung_' + objValueMap[typeObject],
      accessibility_alt: 'kha_nang_truy_cap_mo_ta_anh',
      accessibility_aria_label: 'kha_nang_truy_cap_nhan_nut',
      accessibility_title: 'kha_nang_truy_cap_tieu_de_' + (typeObject == 'video-repeat' ? 'video' : 'ban_do'),
      value_start: 'van_ban_bat_dau',
      value_end: 'van_ban_ket_thuc',
    }
    const messageField = this.languageService.translate(
      messageMap.hasOwnProperty(field) ? messageMap[field] : 'truong_nay'
    );
    const message = this.languageService.translate('dang_dich_cac_ngon_ngu_con_lai_cho')
      + ' ' + messageField.toLowerCase();

    // Hiển thị loading trước khi xử lý
    await this.functionService.showLoading(message, "current-loading", null, 0, false);

    this.functionService.translateToMultipleLanguages(content, { isAdmin: true })
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            if (this.functionService.languageTempCode != lang.code) {
              const translatedItem = data.find(item => item.langCode == lang.code);
              if (translatedItem) {
                itemEdit[`${field}_${lang.code}`] = translatedItem.translatedText
              }
            }
          });
          this.updateData(dataRow);
          this.functionService.createMessage(
            'success', 'dich_va_cap_nhat_thanh_cong', 4000
          );
          this.functionService.hideLoading(300);
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
          this.functionService.createMessage(
            'error', 'loi_dich_thuat_vui_long_thu_lai_hoac_bao_loi_cho_ky_thuat', 5000
          );
          this.functionService.hideLoading(300);
        }
      });
  }
}
